import { ChainedSchema } from '../general/ChainedSchema';
class SerializrType_withInit extends ChainedSchema {
    serializedInitValue;
    empty = [null, undefined];
    constructor(serializedInitValue, propSchema, empty) {
        super(propSchema);
        this.serializedInitValue = serializedInitValue;
        this.empty.push(...empty);
    }
    get providesDefault() {
        return true;
    }
    deserializer(context) {
        if (this.empty.includes(context.json)) {
            if (typeof this.serializedInitValue === 'function') {
                context.json_overwrite = this.serializedInitValue(context);
            }
            else {
                context.json_overwrite = this.serializedInitValue;
            }
        }
        return this.parentSchema.deserializer(context);
    }
}
export function withInit(propSchema, serializedInitValue, empty = []) {
    return new SerializrType_withInit(serializedInitValue, propSchema, empty);
}
